import React from 'react';
import ReactDOM from 'react-dom';
import { connect, Provider } from 'react-redux';
import Banner from './components/Filtering/banners/Banner';

function mapStateToProps(state) {
  const headerBanner = state.listingPage.banner.headerBanner;
  let htmlContent = '';
  if (headerBanner && headerBanner.hasOwnProperty('htmlContent')) {
    htmlContent = headerBanner.htmlContent;
  }

  return { htmlContent };
}

export default function initBanners() {
  const mountEl = document.querySelector('[data-component="headerBanner"]');
  if (mountEl) {
    const ConnectedBanner = connect(mapStateToProps)(Banner);

    ReactDOM.render(
      <Provider store={window.appState}>
        <ConnectedBanner />
      </Provider>,
      mountEl
    );
  }
}
